<form-popup
  titleText="Change Password"
  [visible]="visible"
  [width]="360"
  [height]="410"
  [wrapperAttr]="{ class: 'change-profile-password-popup' }"
  [isSaveDisabled]="isSaveDisabled"
  (save)="saveNewPassword()"
  (visibleChange)="changeVisible($event)"
>
  <dx-form
    #form
    labelMode="outside"
    labelLocation="top"
    [showColonAfterLabel]="true"
  >
    <dxi-item>
      <dxo-label text="Current Password"></dxo-label>
      <password-text-box
        placeholder="Current Password"
        stylingMode="filled"
        [(value)]="formData['currentPassword']"
        (valueChanged)="onFieldChanged()"
      ></password-text-box>
    </dxi-item>

    <dxi-item>
      <div class="h-separator"></div>
    </dxi-item>

    <dxi-item>
      <dxo-label text="Password"></dxo-label>
      <password-text-box
        placeholder="Password"
        stylingMode="filled"
        [(value)]="formData['password']"
        (valueChanged)="onNewPasswordChanged()"
      ></password-text-box>
    </dxi-item>

    <dxi-item>
      <dxo-label text="Confirm Password"></dxo-label>
      <password-text-box
        #confirmField
        placeholder="Confirm Password"
        stylingMode="filled"
        [(value)]="formData['confirmedPassword']"
        [validators]="confirmPasswordValidators"
        (valueChanged)="onFieldChanged()"
      >
      </password-text-box>
    </dxi-item>
  </dx-form>
</form-popup>
